import { Button, Icon } from '@material-ui/core';
import React, { useState } from 'react';
import styled from "styled-components";
import HoaCreateDialog from "../containers/HoaCreateDialog";

const Wrapper = styled.div`
`;

const HoaAddButton = ({ subdivisionId, onAdd }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (entity) => {
    if (entity) {
      onAdd && onAdd(entity);
    }
    setOpen(false);
  };

  return (
    <Wrapper>
      <Button color="default" onClick={handleClickOpen}><Icon>add_circle</Icon> Add</Button>
      <HoaCreateDialog subdivisionId={subdivisionId} onClose={handleClose} open={open} />
    </Wrapper>
  );
}

export default HoaAddButton;
